import type { Step2ValidateCycleResponse } from "@/chargeDetection/types"

export interface Step2ValidateCycleResultsProps {
  data: Step2ValidateCycleResponse
}

export function Step2ValidateCycleResults({ data }: Step2ValidateCycleResultsProps) {
  return (
    <div className="space-y-1">
      <div>Duration: {data.cycle_duration_minutes.toFixed(2)} minutes</div>
      <div>
        Mode check: {data.mode_check_passed ? '✓ Passed' : '✗ Failed'}
      </div>
    </div>
  )
}